import { DRAWER_TYPES, searchFilter, strings } from '@constants'
import { paths } from '@routes'
import { useMemo } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router'
import { PONavigationWrapper, SpoNavigationWrapper } from './style'
import { OutletWrapper, Search } from '@base'
import { Tabs as TabsV2, Button as ButtonV2 } from '@baseV2'
import { Add } from '@material-ui/icons'
import { useDispatch } from 'react-redux'
import { toggleDrawer } from '@data/state/action/root'

const SalesPurchaseOrder2 = () => {
	const navigate = useNavigate()
	const urlParams = useParams()
	const dispatch = useDispatch()
	const { pathname } = useLocation()
	const orderStatus = urlParams?.orderStatus
	const hideTabs = !!orderStatus

	const tabs = useMemo(() => {
		const tabs = [
			{ label: strings('all'), onClick: () => navigate(paths.admin_manage_spo_status('all')), selected: orderStatus === 'all' },
			{ label: strings('active'), onClick: () => navigate(paths.admin_manage_spo_status('active')), selected: orderStatus === 'active' },
			{ label: strings('completed'), onClick: () => navigate(paths.admin_manage_spo_status('completed')), selected: orderStatus === 'completed' },
		]
		return tabs
	}, [orderStatus, pathname, navigate])

	const clickHandler = () => {
		dispatch(toggleDrawer(true, DRAWER_TYPES.OPEN_SEARCH_PANEL, { searchType: searchFilter.PURCHASE_ORDER }))
	}

	return (
		<>
			{hideTabs && (
				<SpoNavigationWrapper>
					<TabsV2 data={tabs} />
					<PONavigationWrapper>
						<ButtonV2
							color='primary'
							
							iconPrefix={<Add fontSize='small' />}
							onClick={() => navigate(paths.admin_create_spo)}
						>
							{strings('create', 'spo')}
						</ButtonV2>
						<Search clickHandler={clickHandler} />
					</PONavigationWrapper>
				</SpoNavigationWrapper>
			)}
			<OutletWrapper>
				<Outlet />
			</OutletWrapper>
		</>
	)
}

export default SalesPurchaseOrder2
